import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { exists, resolveContent, RuntimeModules } from '@nu-art/ts-common';
import { DataStatus } from '../../core/db-api-gen/consts.js';
import './AwaitModules.scss';
import { ThunderDispatcher } from '../../core/thunder-dispatcher.js';
import { ModuleFE_SyncManager } from '../../modules/sync-manager/ModuleFE_SyncManager.js';
import { LL_H_C, LL_V_L } from '../Layouts/Layouts.js';
import { TS_ProgressBar } from '../TS_ProgressBar/TS_ProgressBar.js';
import { ModuleSyncType } from '../../modules/db-api-gen/types.js';
export const dispatch_QueryAwaitedModules = new ThunderDispatcher('__queryAwaitedModule');
export class AwaitModules extends ComponentSync {
    // ######################### Life Cycle #########################
    __onSyncStatusChanged(module) {
        this.logVerbose(`__onSyncStatusChanged: ${module.getCollectionName()}`);
        if (this.state.validModules.includes(module))
            this.reDeriveState();
    }
    __queryAwaitedModule() {
        return resolveContent(this.props.modules);
    }
    constructor(props) {
        super(props);
        const missingModules = resolveContent(this.props.modules).filter(module => !RuntimeModules().includes(module));
        if (missingModules.length)
            this.logWarning('Trying to await modules which are not in the module pack:', missingModules);
    }
    deriveStateFromProps(nextProps, state) {
        //Collect modules that are awaitable
        state.validModules ??= resolveContent(nextProps.modules).filter(module => {
            const validModule = RuntimeModules().includes(module) && exists(module.dbDef);
            if (!validModule)
                this.logWarning(`AwaitModules awaits for module ${module.getName()}, but it isn't a collection module!`);
            return validModule;
        });
        //Collect ready modules
        state.readyModules = state.validModules.filter(module => {
            return module.getDataStatus() === DataStatus.ContainsData || state.ready && module.getDataStatus() === DataStatus.UpdatingData;
        });
        // Set awaiting true if not all valid modules are ready
        state.ready = state.validModules.length === state.readyModules.length;
        state.debug_ShowLoader = !!nextProps.debug_ShowLoader;
        return state;
    }
    shouldComponentUpdate() {
        return true;
    }
    shouldReDeriveState(nextProps) {
        return true;
    }
    // ######################### Logic #########################
    getUnpreparedModules() {
        return this.state.validModules.filter(module => !this.state.readyModules.includes(module));
    }
    getMissingPermissionModules = () => {
        const permissibleModules = ModuleFE_SyncManager.getPermissibleModuleNames();
        if (!permissibleModules.length)
            return [];
        return this.state.validModules.filter(module => module.syncType === ModuleSyncType.APISync && !permissibleModules.includes(module.dbDef.dbKey));
    };
    // ######################### Render #########################
    renderMissingPermissions = () => {
        const missingPermissionModules = this.getMissingPermissionModules();
        if (this.props.customMissingPermissionsRenderer)
            return resolveContent(this.props.customMissingPermissionsRenderer, { modules: missingPermissionModules });
        return _jsx("div", { className: 'ts-await-modules', children: _jsxs(LL_V_L, { className: 'missing-permission-modules', children: [_jsx("h1", { children: "Missing Permissions For The Following Databases" }), _jsx(LL_H_C, { children: missingPermissionModules.map(module => _jsx("span", { children: module.dbDef.entityName }, module.dbDef.dbKey)) })] }) });
    };
    renderLoader = () => {
        const awaitedModules = this.getUnpreparedModules();
        if (this.props.customLoader) {
            return resolveContent(this.props.customLoader, {
                validModules: this.state.validModules,
                readyModules: this.state.readyModules,
                awaitedModules,
                onClick: this.onLoaderClick
            });
        }
        //Calculate Ratios
        const relevantInProgressModules = ModuleFE_SyncManager.getCurrentlySyncingModules()
            .filter(module => this.state.validModules.includes(module));
        const readyAndInProgressModulesRatio = (relevantInProgressModules.length + this.state.readyModules.length) / this.state.validModules.length;
        const readyModulesRatio = this.state.readyModules.length / this.state.validModules.length;
        return _jsx(TS_ProgressBar, { className: 'ts-await-modules', type: 'radial', radius: 10, ratios: [
                readyAndInProgressModulesRatio,
                readyModulesRatio
            ], onClick: this.onLoaderClick });
    };
    onLoaderClick = () => {
        const awaitedModules = this.getUnpreparedModules();
        if (!awaitedModules.length)
            this.logInfo('Not awaiting any modules');
        this.logInfo('Waiting for modules:', ...awaitedModules.map(module => module.getName()));
    };
    render() {
        if (this.state.debug_ShowLoader)
            return this.renderLoader();
        if (this.getMissingPermissionModules().length)
            return this.renderMissingPermissions();
        if (!this.state.ready)
            return this.renderLoader();
        if (this.props.Component)
            return resolveContent(this.props.Component);
        return this.props.children;
    }
}
//# sourceMappingURL=AwaitModules.js.map